module.exports = __webpack_public_path__ + "img/189.8a01ec7f.jpg";